import { WeeklySummary } from '@amzn/aet-summaries-kit';

export interface TeamCSAWeeklySummary {
  alias: string;
  summary: WeeklySummary;
  hasHadSummary: boolean;
}

export interface ManagerFeedbackInput {
  containsFalseOrContradictions: boolean;
  falseOrContradictionsFeedback?: string;
  understandability: number;
  tonality: number;
  willUseInCoaching?: boolean;
  coachingUsabilityFeedback?: string;
  additionalFeedback?: string;
}

export enum ViewContext {
  SELF = 'self',
  DIRECT_REPORT_FROM_TEAM = 'direct_report_from_team',
  OTHER = 'other',
}
